import { Button, Card, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withAuthorization } from "../Session";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";
import { blue, blueGrey, green } from "@material-ui/core/colors";
import { AddAlertOutlined, FlashOnOutlined } from "@material-ui/icons";
import moment from "moment";
import AlertTest from "./AlertTest";

const RealTimeAlerts = (props) => {
  const { firebase } = props;
  const history = useHistory();
  const styles = useStyles();
  const [activeAlerts, setActiveAlerts] = useState([]);
  const [alertsKeys, setAlertsKeys] = useState([]);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [totalDevices, setTotalDevices] = useState(0);
  //const [first, setfirst] = useState(second);

  useEffect(() => {
    var onChildAdded;
    var onChildRemoved;
    firebase
      .alertRef()
      .once("value")
      .then((snap) => {
        if (!!snap.val()) {
          setActiveAlerts(Object.keys(snap.val()).map((a) => ({ ...snap.val()[a], key: a })));
          setAlertsKeys(Object.keys(snap.val()).map((a) => a));
        }
        onChildAdded = firebase.alertRef().on("child_added", (childSnapshot, prevChildKey) => {});

        onChildRemoved = firebase.alertRef().on("child_removed", (childSnapshot) => {
          removeAlert(childSnapshot);
        });
      });

    return () => {
      firebase.alertRef().off("child_added", onChildAdded);
      firebase.alertRef().off("child_removed", onChildRemoved);
    };
  }, []);

  useEffect(() => {
    firebase
      .alertLogRef()
      .once("value")
      .then((snap) => {
        const logs = snap.val();
        const totalDevices = Object.keys(logs).length;
        const totalAlerts = Object.keys(logs)
          .map((k) => Object.keys(logs[k]).length)
          .reduce((p, c) => p + c, 0);
        setTotalDevices(totalDevices);
        setTotalAlerts(totalAlerts);
        console.log(totalAlerts);
      });
  }, []);

  const addAlert = (childSnapshot) => {
    console.log("Al añadir, stado", activeAlerts);
    let alerts = activeAlerts.map((a) => a);
    let index = alertsKeys.map((k) => k);
    alerts.push({ ...childSnapshot.val(), key: childSnapshot.key });
    index.push(childSnapshot.key);
    setActiveAlerts(alerts.map((a) => a));
    setAlertsKeys(index);
  };

  const removeAlert = (childSnapshot) => {
    let alerts = activeAlerts.map((a) => a);
    let index = alertsKeys.map((k) => k);
    const i = alertsKeys.indexOf(childSnapshot.key);
    alerts.splice(i, 1);
    index.splice(i, 1);
    setActiveAlerts(alerts);
    setAlertsKeys(index);
  };

  return (
    <Grid container className={styles.maindGrid} justify="center">
      <Grid item xs={12} lg={10} container spacing={4} style={{ paddingBottom: 64 }}>
        <Grid item xs={12} style={{ marginTop: 32 }} container alignItems="flex-end">
          <Typography variant="h4" style={{ color: blueGrey[50] }}>
            Reanibex Alert
          </Typography>
          &nbsp;
          <Typography variant="h5" style={{ color: blueGrey[100] }}>
            {"· Gestión de Alertas"}
          </Typography>
        </Grid>

        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} lg={8}>
            <Typography variant="h6" style={{ color: blueGrey[50], marginBottom: 16 }}>
              Resumen
            </Typography>
            <Card style={{ padding: 16, borderRadius: 9, minHeight: 172 }}>
              <Grid item xs={12} container spacing={2}></Grid>
            </Card>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Typography variant="h6" style={{ color: blueGrey[50], marginBottom: 16 }}>
              Alertas en tiempo real
            </Typography>
            {activeAlerts.map((x) => (
              <AlertCard data={x} history={history} key={x.key} />
            ))}
            {activeAlerts.length == 0 && (
              <Grid item xs={12}>
                <Card style={{ padding: 16, borderRadius: 9 }}>
                  <Typography variant="body1">No hay ninguna alerta abierta ahora mismo</Typography>
                </Card>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={2}>
          <Grid item>
            <Typography variant="h5" color="primary">
              Pruebas de comunicación
            </Typography>
          </Grid>
          <Grid item xs={12} container></Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          spacing={4}
          style={{
            marginTop: 32,
            backgroundColor: blueGrey[50],
            borderRadius: 8,
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h5" color="primary">
              Registro de alertas
            </Typography>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <AlertLogCard value={totalDevices} item={"Dispositivos"} color={blue} icon={<FlashOnOutlined style={{ fontSize: 36, color: blue[50] }} />} />
            <AlertLogCard value={totalAlerts} item="Alertas Totales" color={green} icon={<AddAlertOutlined style={{ fontSize: 36, color: blue[50] }} />} />
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          spacing={4}
          style={{
            marginTop: 32,
            backgroundColor: blueGrey[50],
            borderRadius: 8,
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h5" color="primary">
              Test comunicaciones
            </Typography>
          </Grid>

          <AlertTest />
        </Grid>
      </Grid>
    </Grid>
  );
};

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(RealTimeAlerts);

const AlertLogCard = ({ value, item, icon, color }) => (
  <Grid item xs={6} md={2}>
    <Card style={{ padding: "12px 6px", backgroundColor: color[400] }}>
      <Grid container item xs={12} alignItems="center">
        <Grid item xs={9} container>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: color[100] }}>
              {value}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" style={{ color: color[100] }}>
              {item}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3} justify="center" alignItems="center">
          {icon}
        </Grid>
      </Grid>
    </Card>
  </Grid>
);

const AlertCard = ({ data, history }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    var intervalId = window.setInterval(() => {
      const now = new Date().getTime();
      const t = moment.duration(now - data.start, "milliseconds");
      setElapsedTime(`${t.minutes()}:${t.seconds()}`);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Card
      style={{
        backgroundImage: "linear-gradient(90deg,transparent,white),url('https://t3.ftcdn.net/jpg/04/49/73/64/360_F_449736488_IAGo58o7DloC8Os5S5v9vppX3BIxzK4S.jpg')",
      }}
    >
      <Grid container direction="row" spacing={2} style={{ padding: 16 }}>
        <Grid container direction="column" item xs={8}>
          <Typography variant="h6" style={{ fontSize: 18, fontWeight: 500 }}>
            Tiempo transcurrido {elapsedTime}
          </Typography>

          <Typography variant="h6" style={{ fontSize: 18, fontWeight: 500 }}>
            Voluntarios alertados
          </Typography>

          <Typography variant="h6" style={{ fontSize: 18, fontWeight: 500 }}>
            Voluntarios notificados
            {data?.alertStatistics?.firstAlertSuccesCount}
          </Typography>
        </Grid>
        <Grid item xs={4} container alignItems="center" justify="center">
          <Button variant="outlined" onClick={() => history.push(ROUTES.ALERT_LOG.replace(":key", data.key))}>
            ver
          </Button>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          backgroundImage: "linear-gradient(0deg,rgba(0,0,0,.9),rgba(0,0,0,0))",
          padding: "12px 12px",
        }}
      >
        <Typography variant="h6" style={{ color: blueGrey[50] }}>
          {data.key.substring(0, 30) + "..."}
        </Typography>
      </Grid>
    </Card>
  );
};

const useStyles = makeStyles((theme) => ({
  maindGrid: {
    background: `linear-gradient( #9933CC 0 232px, transparent 232px 100%)`,
    minHeight: "100vh",
  },
}));
